module.exports = __webpack_public_path__ + "a260c22deef5eaca0e38f0ba081db881.png";